var e=(e,o,t="some")=>o[t](o=>o[e]);export{e as getUseQueryHookState};
//# sourceMappingURL=getUseQueryHookState.js.map